var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LibBaseIcon',{attrs:{"size":_vm.size}},[_c('path',{attrs:{"transform":"","d":"M96 71.973H71.973V96H24V48.027h24.027V24H96zm-30.014 18.04v-18.04h-17.96v-17.96h-18.04v36zm24.028-60.027h-36v36h36z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }